/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import styles from './hiddenSectionEmails.module.css';
import { useStores } from '../../hooks/useStore';
import { observer } from 'mobx-react';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Chip,
} from '@mui/material';
import { Button } from '../../components/UI/Button/Button';
import { ReactComponent as EditIco } from './icon/edit.svg';
import { HiddenSectionEmailsModel } from '../../models/hiddenSectionEmails';
import HiddenSectionEmailsPopUP from '../../components/popUp/HiddenSectionEmails/HiddenSectionEmails';

const HiddenSectionEmails: React.FC = observer(() => {
  const api = useApi();
  const store = useStores();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [showForm, setShowForm] = useState<boolean>(false);

  const [items, setItems] = useState<HiddenSectionEmailsModel[]>([]);

  useEffect(() => {
    loadItems();
  }, [page, rowsPerPage]);

  const loadItems = async () => {
    try {
      store.notificationsStore.showPreloader();
      const { body } = await api.hiddenSectionEmails.get(
        page * rowsPerPage,
        rowsPerPage,
      );

      if (body) {
        setItems(body);
      }
    } catch (e) {
      store.notificationsStore.setError('Ошибка при загрузке');
    } finally {
      store.notificationsStore.hidePreloader();
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const closeForm = () => {
    setShowForm(false);
    setItem(null);
  };

  const update = () => {
    loadItems();
  };

  const [item, setItem] = useState<HiddenSectionEmailsModel | null>(null);

  const editItem = (selectedItem: HiddenSectionEmailsModel) => {
    setItem(selectedItem);
    setShowForm(true);
  };

  return (
    <>
      {showForm && (
        <HiddenSectionEmailsPopUP
          onClose={closeForm}
          update={update}
          item={item}
        />
      )}
      <div className={styles.container}>
        <div className={styles.pageName}>
          <div className={styles.top}>
            <div className={styles.title}>
              <h2>Скрытие в app</h2>
            </div>
            <Button
              style={{ maxWidth: 150 }}
              appearance="auth"
              onClick={() => setShowForm(showForm ? false : true)}
            >
              Добавить
            </Button>
          </div>
        </div>

        <div style={{ width: '100%', maxWidth: 1500, margin: '5px' }}>
          <Paper
            sx={{
              width: '100%',
              maxWidth: 1500,
              margin: '5px',
              overflowX: 'auto',
            }}
          >
            <TableContainer style={{ marginTop: 20, overflowX: 'auto' }}>
              <Table sx={{ minWidth: 320 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Email</TableCell>
                    <TableCell align="center">iOS</TableCell>
                    <TableCell align="center">Android</TableCell>
                    <TableCell align="right">Действие</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items &&
                    items.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                          }}
                        >
                          <>
                            <TableCell component="th" scope="row">
                              {row.email}
                            </TableCell>
                            <TableCell align="center">
                              {row.platform_ios ? (
                                <Chip label="Да" color="success" size="small" />
                              ) : (
                                <Chip
                                  label="Нет"
                                  color="default"
                                  size="small"
                                />
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {row.platform_android ? (
                                <Chip label="Да" color="success" size="small" />
                              ) : (
                                <Chip
                                  label="Нет"
                                  color="default"
                                  size="small"
                                />
                              )}
                            </TableCell>

                            <TableCell align="right">
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'flex-end',
                                  alignItems: 'center',
                                }}
                              >
                                <EditIco
                                  className={styles.tagDeleteIco}
                                  onClick={() => {
                                    editItem(row);
                                  }}
                                />
                              </div>
                            </TableCell>
                          </>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div
              style={{ width: '100%', height: 1, backgroundColor: '#E0E0E0' }}
            />
            <TablePagination
              labelRowsPerPage="Строк на странице"
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={items ? items.length : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>
    </>
  );
});

export default HiddenSectionEmails;
